import type { DropDownListChangeEvent } from "@tql/ui-components-react/kendo/dropdowns";
import type {
	GridCustomCellProps,
	GridItemChangeEvent,
} from "@tql/ui-components-react/kendo/grid";
import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import type {
	RoutingGuideEnumItem,
	RoutingGuideEnumsType,
} from "~/shared/schemas/routing-guide-schema.ts";

import type { CarrierRule, RowUpdate } from "../../../modal/utils/types.ts";

type CarrierFieldSelectorCellProps = GridCustomCellProps & {
	handleCarrierRowChange: (
		event: GridItemChangeEvent | RowUpdate<CarrierRule>,
	) => void;
	routingGuideEnums?: RoutingGuideEnumsType;
	showActivationError?: boolean;
	cellTestId?: string;
};

export const CarrierFieldSelectorCell = ({
	handleCarrierRowChange,
	routingGuideEnums,
	showActivationError,
	...props
}: CarrierFieldSelectorCellProps) => {
	const dataItem = props.dataItem as CarrierRule;
	const fieldSelectors = routingGuideEnums?.thenFieldSelectors ?? [];
	const selectedField =
		fieldSelectors.find((c) => c.name === dataItem.fieldSelector) ?? null;

	const hasError = showActivationError === true && !dataItem.fieldSelector;

	return (
		<GridTd data-testid={props.cellTestId} tdProps={props.tdProps}>
			<div
				style={
					hasError
						? {
								outline: "2px solid var(--kendo-color-error)",
								borderRadius: "2px",
							}
						: undefined
				}
			>
				<DropDownList
					data={fieldSelectors}
					dataItemKey={"value"}
					onChange={(e: DropDownListChangeEvent) => {
						const selected = e.value as RoutingGuideEnumItem;
						handleCarrierRowChange({
							dataItem,
							field: "fieldSelector" as keyof CarrierRule,
							value: selected.name,
						});
					}}
					textField={"label"}
					value={selectedField}
				/>
			</div>
			{hasError ? (
				<span
					style={{
						color: "var(--kendo-color-error)",
						display: "block",
						fontSize: "11px",
						marginTop: "2px",
					}}
				>
					A value must be input in order to activate
				</span>
			) : null}
		</GridTd>
	);
};
